export const otherMutationSitecoreLabels = {
  HeadingDescription: { value: "Beschrijf wat je wil wijzigen" },
  InfoDescription: { value: "Maximaal 2000 karakters" },
  PlaceholderDescription: { value: "Type je wijziging..." },
  TooltipDescription: { value: "" },
  HeadingStartDate: { value: "Per wanneer geldt deze wijziging?" },
  InfoStartDate: { value: "Optioneel" },
  PlaceholderStartDate: { value: "Kies de ingangsdatum" },
  TooltipStartDate: { value: "" },
};
